module.exports = __webpack_public_path__ + "img/premio-box-icon_578x578.699debe1.png";